import React, { useEffect } from "react";
import { useWatch } from "react-hook-form/dist/index.ie11";

interface IFormWatcherProps {
  control: any;
  onChange: (values: any) => void;
}

export const FormWatcher = React.memo(
  ({ control, onChange }: IFormWatcherProps) => {
    const values = useWatch({ control });

    useEffect(() => {
      onChange(values);
    }, [values, onChange]);

    return null;
  }
);

FormWatcher.displayName = "FormWatcher";
